// extracted by mini-css-extract-plugin
export default {"carousel":"Tabs_carousel__Moq9U","carouselCell":"Tabs_carouselCell__zyviP","active":"Tabs_active__uGUKx"};